import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { userEdit } from "../redux/modules/userSlice";
import Backdrop from "../components/Backdrop";
import DynamicDataGrid from "../components/dynamicDataGrid";
import UserAdditon from "./userAdditon";

const UsersLists = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [usersListRows, setUsersListRows] = useState([]);
  const [sortModel, setSortModel] = useState([
    { field: "date_created", sort: "desc" },
  ]);
  const navigate = useNavigate();
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [queryOptions, setQueryOptions] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const dispatch = useDispatch();
  const [paginationModel, setPaginationModel] = useState({
    page: Number(searchParams.get("page")) - 1 || 0,
    pageSize: 10,
  });
  const [showLoading, setShowLoading] = useState(true);
  const [addUserOpen, setAddUserOpen] = useState(false);

  const HandleRowClick = (row) => {
    const currentUrl = window.location.href;
    sessionStorage.setItem("UserpreviousUrl", currentUrl);
    dispatch(userEdit(row.id));
    navigate(`/UsersDetails/${row.id}?tab=b_info`);
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const handleSortModelChange = React.useCallback(
    (sortModel) => {
      setSortModel(sortModel);
      setQueryOptions({ sortModel: [...sortModel] });
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
      setSearchParams({ page: 1, search: searchQuery });
    },
    [searchQuery],
  );

  const listofUsersApi = async () => {
    let payload = {};
    setShowLoading(true);
    const page = searchParams.get("page") || 1;
    const searchQueryParam = searchParams.get("search") || "";

    if (queryOptions.sortModel?.length > 0) {
      payload.sortField = queryOptions.sortModel[0].field;
      payload.sortBy = queryOptions.sortModel[0].sort;
    }
    payload.pageSize = queryOptions.pageSize || 10;
    try {
      const response = await axios.post(
        `list-of-users/${page}${searchQueryParam ? "?search=" + searchQueryParam : ""}`,
        payload,
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      );
      setTotalCount(response.data.message.total);
      setUsersListRows(response.data.message.userListResponse);
      dispatch(userEdit(null));
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoading(false);
    }
  };

  const handleAddUser = () => {
    dispatch(userEdit(null));
    setAddUserOpen(true);
  };

  const handlePaginationModelChange = (model) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setPaginationModel({ ...paginationModel, ...model });
    setSearchParams({ page: model.page + 1 });
    setQueryOptions({ ...queryOptions, pageSize: model.pageSize });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    setSearchParams({
      page: 1,
      search: debouncedSearch,
    });
  }, [debouncedSearch]);

  useEffect(() => {
    const query = searchParams.get("search") || "";
    const page = Number(searchParams.get("page")) || 1;
    setSearchQuery(query);
    setPaginationModel((prev) => ({ ...prev, page: page - 1 }));
    listofUsersApi();
  }, [searchParams, queryOptions]);

  return (
    <Box className="pageWrapper">
      {/* ── Header row ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          // mb: 1,
        }}
      >
        <Typography
          sx={{ fontSize: "18px", fontWeight: 600, color: "#151D48" }}
        >
          Users
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <TextField
            id="standard-search"
            type="search"
            variant="outlined"
            placeholder="Search"
            autoComplete="off"
            size="small"
            onChange={handleSearch}
            value={searchQuery}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "18px", color: "#94a3b8" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              width: "240px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                fontSize: "13px",
                backgroundColor: "#F8FAFC",
                height: "32px",
              },
            }}
          />
          <Button
            startIcon={<AddIcon />}
            onClick={handleAddUser}
            variant="contained"
            sx={{
              backgroundColor: "#3F95EA",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "15px",
              px: 2,
              height: "32px",
              "&:hover": { backgroundColor: "#005a9e" },
            }}
          >
            Add User
          </Button>
        </Box>
      </Box>

      {/* ── Table ── */}
      <Box
        sx={{
          height: "100%",
          overflowY: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <DynamicDataGrid
          rows={usersListRows}
          loading={showLoading}
          showCheckbox={false}
          onRowSelection={HandleRowClick}
          totalRows={totalCount}
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          noRowsText="No User Found"
        />
      </Box>

      {addUserOpen && (
        <UserAdditon
          open={addUserOpen}
          onClose={() => setAddUserOpen(false)}
          onSuccess={listofUsersApi}
          disableNavigation
        />
      )}
    </Box>
  );
};

export default UsersLists;
